const TYPE_MAP = {
	'orders.repair.messages.created': notification => ({
		title: notification.data.title,
		linkTitle: 'Просмотр заявки',
		to: `/orders/repair/${notification.data.repair_order_id}`,
	}),
}

export default class NotificationMapper {
	#map;

	constructor() {
		this.#map = TYPE_MAP;
	}

	execute(notification) {
		return this.#map[notification.type](notification);
	}
}
